module.exports = __webpack_public_path__ + "static/media/table-shapes.e221cfae.svg";